const CLICK_REF_PARAM = 'clickref';
const MAX_CLICK_REF_LENGTH = 255;
const PRINTABLE_ASCII = /^[ -~]+$/;
const UNSAFE_IN_A_QUERY_VALUE = /[&#%=+<>"'\\]/;

// The card that opens the interstitial has already told WeCanTrack about the
// click under its own clickref, so the interstitial sends the retailer that same
// one; a second, freshly minted reference would never match the tracker's record.
export function getClickOutUrl({
  affiliateId,
  baseUrl,
  clickRef,
  productId
}: {
  affiliateId: string;
  baseUrl: string;
  clickRef: string;
  productId: number | string;
}) {
  const path = `${baseUrl}/co/${productId}/${affiliateId}`;

  if (!isForwardableClickRef(clickRef, productId)) return path;

  return `${path}?${new URLSearchParams({ [CLICK_REF_PARAM]: clickRef })}`;
}

export function getForwardedClickRef(
  searchParams: URLSearchParams,
  productId: string
): string | undefined {
  const clickRef = searchParams.get(CLICK_REF_PARAM);

  if (!isForwardableClickRef(clickRef, productId)) return;

  return clickRef;
}

export function isForwardableClickRef(
  clickRef: null | string | undefined,
  productId: number | string
): clickRef is string {
  if (!clickRef || !productId) return false;
  if (clickRef.length > MAX_CLICK_REF_LENGTH) return false;
  if (!clickRef.startsWith('ts:')) return false;
  if (!clickRef.includes(`_pid:${productId}_`)) return false;
  if (!PRINTABLE_ASCII.test(clickRef)) return false;

  return !UNSAFE_IN_A_QUERY_VALUE.test(clickRef);
}
